let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bs7yU")).then(() => parcelRequire('4QtcT'));